import { ProductType } from 'shared/openapi/models';

export interface ProductTypeRange {
	key: ProductType;
	loanTerm: {
		minYears: number;
		maxYears: number;
		minMonths: number;
		maxMonths: number;
	};
	loanAmount: {
		min: number;
		max: number;
	};
}

export const babavaroRange: ProductTypeRange = {
	key: ProductType.Babavaro,
	loanTerm: {
		minYears: 5,
		maxYears: 20,
		minMonths: 5 * 12,
		maxMonths: 20 * 12,
	},
	loanAmount: {
		min: 1_000_000,
		max: 11_000_000,
	},
};

export const csokPlusRange: ProductTypeRange = {
	key: ProductType.CsokPlusz,
	loanTerm: {
		minYears: 10,
		maxYears: 25,
		minMonths: 10 * 12,
		maxMonths: 25 * 12,
	},
	loanAmount: {
		min: 1_000_000,
		max: 50_000_000,
	},
};

export const jelzalogRange: ProductTypeRange = {
	key: ProductType.Jelzalog,
	loanTerm: {
		minYears: 1,
		maxYears: 35,
		minMonths: 1 * 12,
		maxMonths: 35 * 12,
	},
	loanAmount: {
		min: 1_000_000,
		max: 999_000_000,
	},
};

export const otthonStartRange: ProductTypeRange = {
	key: ProductType.OtthonStart,
	loanTerm: {
		minYears: 1,
		maxYears: 25,
		minMonths: 1 * 12,
		maxMonths: 25 * 12,
	},
	loanAmount: {
		min: 1_000_000,
		max: 50_000_000,
	},
};

export const ranges: ProductTypeRange[] = [babavaroRange, csokPlusRange, jelzalogRange, otthonStartRange];

export const getRange = (key: ProductType): ProductTypeRange =>
	ranges.find((range) => range.key === key) as ProductTypeRange;

export const getLoanTermRange = (key: ProductType) => {
	const range = getRange(key);
	return range.loanTerm;
};

export const getLoanAmountRange = (key: ProductType) => {
	const range = getRange(key);
	return range.loanAmount;
};

export const getMinLoanTermYears = (key: ProductType) => {
	const range = getLoanTermRange(key);
	return range.minYears;
};

export const getMaxLoanTermYears = (key: ProductType) => {
	const range = getLoanTermRange(key);
	return range.maxYears;
};

export const getMinLoanTermMonths = (key: ProductType) => {
	const range = getLoanTermRange(key);
	return range.minMonths;
};

export const getMaxLoanTermMonths = (key: ProductType) => {
	const range = getLoanTermRange(key);
	return range.maxMonths;
};

export const getMinLoanAmount = (key: ProductType) => {
	const range = getLoanAmountRange(key);
	return range.min;
};

export const getMaxLoanAmount = (key: ProductType) => {
	const range = getLoanAmountRange(key);
	return range.max;
};
